import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { SortType, type SortType as SortTypeValue } from '@eti/schema-types';
import { quickSortPricesType } from '../../../../constants/quickSortConstants';
import QuickSortButton from './QuickSortButton';

const buttonBarContainerStyles = css`
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 0;
`;

const quickSortButtons = [
  {
    type: SortType.Recommendation,
    icon: 'medal',
    labelKey: 'Result.QuickFilter.Recommended.Button',
  },
  {
    type: SortType.CarrierPromo,
    icon: 'star',
    labelKey: 'Result.QuickFilter.Campaign.Button',
  },
  {
    type: SortType.CheapTrip,
    icon: 'dollarsign',
    labelKey: 'Result.QuickFilter.Cheapest.Button',
  },
  {
    type: SortType.ShortTrip,
    icon: 'clock',
    labelKey: 'Result.QuickFilter.Shortest.Button',
  },
];

interface QuickSortButtonBarProps {
  selectedSortType?: SortTypeValue;
  sortPrices: Record<string, number>;
  onSort: (sortType: SortType) => void;
}

const QuickSortButtonBar = ({
  selectedSortType = SortType.Recommendation,
  sortPrices,
  onSort,
}: QuickSortButtonBarProps) => {
  const { t } = useTranslation();

  return (
    <div className={buttonBarContainerStyles}>
      {quickSortButtons.map(({ icon, type, labelKey }, index: number) => (
        <QuickSortButton
          formattedPrice={priceUtil.formatPrice(sortPrices[quickSortPricesType[type]])}
          icon={icon}
          id={index === 0 ? 'first-quick-sort-button-v1' : undefined}
          isSelected={selectedSortType === type}
          key={type}
          label={t(labelKey)}
          onClick={onSort}
          type={type}
        />
      ))}
    </div>
  );
};

export default QuickSortButtonBar;
